
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../state/auth';

export const BottomNav = React.memo(({ active = 'home' }: { active?: string }) => {
    const { user } = useAuth();
    const navigate = useNavigate();
    
    const navItems = [
        { id: 'home', icon: 'home', label: 'Inicio', path: '/home' },
        { id: 'catalog', icon: 'grid_view', label: 'Catálogo', path: '/catalog' },
        { id: 'live', icon: 'bolt', label: 'LIVE', path: '/club', isSpecial: true },
        { id: 'orders', icon: 'local_shipping', label: 'Pedidos', path: '/tracking' },
        { id: 'profile', icon: 'person', label: 'Perfil', path: '/profile' },
    ];

    return (
        <nav className="w-full pb-safe pt-2 px-4 pointer-events-auto bg-gradient-to-t from-background-light dark:from-background-dark to-transparent" aria-label="Main navigation" role="navigation">
            <div className="bg-white/30 dark:bg-black/30 backdrop-blur-3xl border border-white/20 dark:border-white/5 shadow-[0_-10px_40px_-15px_rgba(0,0,0,0.1)] rounded-2xl md:rounded-3xl h-[72px] flex items-end justify-between px-1 relative z-50">

                {navItems.map((item) => {
                    const isActive = active === item.id;

                    if (item.isSpecial) {
                        return (
                            <div key={item.id} className="flex-1 flex justify-center h-full relative">
                                <button
                                    onClick={() => {
                                        if(user) {
                                            navigate(item.path);
                                        } else {
                                            navigate('/login');
                                        }
                                    }}
                                    className="relative -top-6 group"
                                    aria-label={user ? `Navigate to ${item.label}` : 'Login required'}
                                    aria-current={isActive ? 'page' : undefined}
                                >
                                    <div className={`flex flex-col items-center justify-center w-16 h-16 rounded-full border-4 border-background-light dark:border-background-dark shadow-lg shadow-primary/30 transition-all duration-300 active:scale-95 ${isActive ? 'bg-primary text-white scale-110' : 'bg-surface-dark dark:bg-white text-primary dark:text-primary'}`}>
                                        <span className={`material-symbols-outlined text-[32px] ${isActive ? 'filled' : ''} transition-transform group-hover:rotate-12 animate-pulse`}>
                                            {!user ? 'lock' : item.icon}
                                        </span>
                                    </div>
                                    <span className={`absolute -bottom-6 left-1/2 -translate-x-1/2 text-[10px] font-black tracking-widest uppercase transition-colors duration-300 ${isActive ? 'text-primary' : 'text-text-secondary dark:text-gray-500'}`}>
                                        {item.label}
                                    </span>
                                </button>
                            </div>
                        );
                    }

                    return (
                        <Link key={item.id} to={item.path} className="flex-1 flex flex-col items-center justify-end pb-3 gap-1 h-full min-h-[44px] cursor-pointer group select-none relative" aria-label={`Navegar a ${item.label}`} aria-current={isActive ? 'page' : undefined}>
                            <span className={`material-symbols-outlined text-[26px] transition-all duration-300 group-active:scale-90 ${isActive ? 'filled text-primary -translate-y-1' : 'text-text-secondary dark:text-gray-500 hover:text-text-main dark:hover:text-white'}`}>
                                {item.icon}
                            </span>
                            <span className={`text-[10px] font-bold transition-all duration-300 ${isActive ? 'text-primary translate-y-0' : 'text-text-secondary dark:text-gray-500'}`}>
                                {item.label}
                            </span>
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
});

BottomNav.displayName = 'BottomNav';
